/**
 * Composer package `holz100/flarum-statikapp-customization` resolves to this
 * extension id, which is also the prefix of every setting key.
 */
export const EXTENSION_ID = 'holz100-statikapp-customization';

export const SETTINGS = {
  autoOpenLogin: `${EXTENSION_ID}.auto_open_login`,
  loginMessage: `${EXTENSION_ID}.login_message`,
  messageStyle: `${EXTENSION_ID}.message_style`,
  modalWidth: `${EXTENSION_ID}.modal_width`,
  autoActivateUsers: `${EXTENSION_ID}.auto_activate_users`,
  disableRegistrationEmails: `${EXTENSION_ID}.disable_registration_emails`,
};

/** Forum attributes as exposed by `Extend\Settings::serializeToForum()` in extend.php. */
export const ATTRIBUTES = {
  autoOpenLogin: 'holz100StatikAppCustomization.autoOpenLogin',
  loginMessage: 'holz100StatikAppCustomization.loginMessage',
  messageStyle: 'holz100StatikAppCustomization.messageStyle',
  modalWidth: 'holz100StatikAppCustomization.modalWidth',
};

/**
 * How the message is rendered. `plain` is the default and keeps the original
 * text-only look; the others wrap it in one of Flarum's `Alert` boxes.
 */
export const MESSAGE_STYLES = ['plain', 'info', 'warning', 'error'];

/**
 * Widths map onto Flarum's own modal classes, so the core responsive rules
 * (full width on phones, `width: 100%` capping below the max) still apply:
 * `default` = Modal--small (375px), `medium` = base modal (600px),
 * `large` = Modal--large (800px).
 */
export const MODAL_WIDTHS = ['default', 'medium', 'large'];
